enum BoolQuestionAnswerStrategy {
    ON_YES,
    ON_NO
}

export default BoolQuestionAnswerStrategy
